import '@abgov/web-components'; //NOTE: this line needs to be here otherwise the components won't render correctly
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import {
  GoabButton,
  GoabButtonGroup,
  GoabMicrositeHeader,
  GoabAppHeader,
  GoabCallout,
  GoabNotification,
  GoabModal,
  GoabIcon,
  GoabIconButton,
  GoabAccordion,
  GoabBadge,
  GoabContainer,
  GoabGrid,
  GoabTable,
  GoabTabs,
  GoabTab,
  GoabFormItem,
  GoabDetails,
  GoabFileUploadInput,
  GoabDivider,
  GoabSpacer,
  GoabInput,
  GoabTextArea,
  GoabRadioItem,
  GoabRadioGroup,
  GoabInputNumber,
  GoabBlock,
  GoabDatePicker,
  GoabDropdown,
  GoabDropdownItem,
  GoabCheckbox,
  GoabAppHeaderMenu,
  GoabMenuButton,
  GoabMenuAction,
  GoabAppFooter,
} from '@abgov/angular-components';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    GoabButton,
    GoabButtonGroup,
    GoabMicrositeHeader,
    GoabAppHeader,
    GoabCallout,
    GoabNotification,
    GoabModal,
    GoabIcon,
    GoabIconButton,
    GoabAccordion,
    GoabBadge,
    GoabContainer,
    GoabGrid,
    GoabTable,
    GoabTabs,
    GoabTab,
    GoabFormItem,
    GoabDetails,
    GoabFileUploadInput,
    GoabDivider,
    GoabSpacer,
    GoabInput,
    GoabTextArea,
    GoabRadioItem,
    GoabRadioGroup,
    GoabInputNumber,
    GoabBlock,
    GoabDatePicker,
    GoabDropdown,
    GoabDropdownItem,
    GoabCheckbox,
    GoabAppHeaderMenu,
    GoabMenuButton,
    GoabMenuAction,
    GoabAppFooter,
  ],
  exports: [
    GoabButton,
    GoabButtonGroup,
    GoabMicrositeHeader,
    GoabAppHeader,
    GoabCallout,
    GoabNotification,
    GoabModal,
    GoabIcon,
    GoabIconButton,
    GoabAccordion,
    GoabBadge,
    GoabContainer,
    GoabGrid,
    GoabTable,
    GoabTabs,
    GoabTab,
    GoabFormItem,
    GoabDetails,
    GoabFileUploadInput,
    GoabDivider,
    GoabSpacer,
    GoabInput,
    GoabTextArea,
    GoabRadioItem,
    GoabRadioGroup,
    GoabInputNumber,
    GoabBlock,
    GoabDatePicker,
    GoabDropdown,
    GoabDropdownItem,
    GoabCheckbox,
    GoabAppHeaderMenu,
    GoabMenuButton,
    GoabMenuAction,
    GoabAppFooter,
  ],
})
export class GoabUiModule {}
